import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { IInvoice, ISearchInvoice, IInvoiceStatus, IInvoicePeriodStatus } from "../models/IInvoice";
import { objectToQueryString } from "../helpers/ApiHelper";
import { ICareProvider } from "../models/ICareProvider";


export class SearchInvoiceApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    searchInvoices(searchParams: ISearchInvoice, exportToExcel: boolean, success?: (data: IPaginatedResponse<IInvoice[]>) => void, fileName?: string, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        if (exportToExcel) {
            this.getFile(`${Utils.LIB_API_BASE_URL}/searchInvoice?${queryString}&exportToExcel=true`, fileName, undefined, error, final);
        }
        if (success) {
            this.getPaginated<IInvoice[]>(`${Utils.LIB_API_BASE_URL}/searchInvoice?${queryString}`, success, error, final);
        }
    }

    getInvoiceStatuses(success: (data: IInvoiceStatus[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/searchInvoice/invoiceStatuses`, success, error, final);
    }

    getUmbrellaOrganisations(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/searchInvoice/umbrellaOgranisations`, success, error, final);
    }

    getCareProvidersByUmbrellaCareProviderId(umbrellaCareProviderId: number, treatmentTypeId: string, success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider[]>(`${Utils.LIB_API_BASE_URL}/searchInvoice/careProviders/${umbrellaCareProviderId}/${treatmentTypeId == undefined ? "" : treatmentTypeId}`, success, error, final);
    }

    getInvoicePeriodStatus(success: (data: IInvoicePeriodStatus) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/searchInvoice/invoicePeriodStatus`, success, error, final);
    }
}